<template>
  <div
    class="d-inline-block"
    @click.stop="toggleValue"
  >
    <v-btn
      fab
      icon
      x-small
      @click.stop="toggleValue"
    >
      <v-icon :color="isTrue ? 'green' : 'grey lighten-2'">
        {{ isTrue ? 'fa-check-circle' : 'fa-circle' }}
      </v-icon>
    </v-btn>
    <span style="color: #666; padding-left: 5px">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'SearchToggleCheckbox',

  props: {
    value: {
      type: [Boolean, String, Number],
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    falseValue: {
      type: [String, Number],
      default: '',
    },
    trueValue: {
      type: [String, Number],
      default: '',
    },
  },

  computed: {
    isTrue() {
      return this.value === this.trueValue
    },
  },

  methods: {
    toggleValue() {
      this.$emit(
        'input',
        this.value === this.falseValue ? this.trueValue : this.falseValue
      )
    },
  },
}
</script>
